import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { CONTACT_WIZARD_SAMPLE } from "../consts";
import { getContactName } from "../helpers";
import { ContactWizardSceneProps } from "../types";

/** Korak "Email": popis adresa s primarnom i nova adresa u unosu. */
const EmailScene: React.FC<ContactWizardSceneProps> = ({ formValues }) => {
  const name = getContactName(formValues);
  const [primaryEmail] = CONTACT_WIZARD_SAMPLE.emails;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Email adrese</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {CONTACT_WIZARD_SAMPLE.emails.map((email) => (
              <div key={email.value} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-slate-800 truncate">{email.value}</span>
                  {email.primary && (
                    <span className="px-1.5 py-0.5 rounded-full bg-emerald-100 text-[0.55rem] font-semibold text-emerald-700 flex-shrink-0">
                      Primarni
                    </span>
                  )}
                </div>
                <div className="text-[0.6rem] text-slate-400 truncate">{email.description}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Nova poruka</div>
          <div className="mt-3 space-y-2 text-[0.65rem]">
            <div className="flex items-center gap-2">
              <span className="text-slate-400">Za</span>
              <span className="font-semibold text-slate-700 truncate">{primaryEmail.value}</span>
            </div>
            <div className="h-1.5 w-full rounded-full bg-slate-100" />
            <div className="h-1.5 w-4/5 rounded-full bg-slate-100" />
            <div className="h-1.5 w-3/5 rounded-full bg-slate-100" />
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Primarni email ide prvi"
          subtitle="Ostale adrese ostaju pri ruci"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M22 6l-10 7L2 6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(EmailScene);
